// extracted by mini-css-extract-plugin
export default {"root":"bkCeXtcvFCMGQnOc5I7Q","wrap":"w1J3uCr3td4Gh31yYT8n","main":"wCxcRWOpLElsC3LG3Df1","header":"NAN3cBhy9S617T66ZMok"};